import collectionTip from '../view/collection-tip.html'
import utils from 'utils'
class collectionExportCtrl {
    constructor($scope, collectionExportService, httpRequest, $uibModal, logger) {
        //         所有锁死期为下月则为已上报
        // 所有锁死期为下月且没有报税资料
        // NOTE: 进页面查询一次金税盘信息

        const upMonth = new Date().getMonth() + 2
        const now = upMonth > 12 ? `${new Date().getFullYear() + 1}${ `0${upMonth-12}`}` : `${new Date().getFullYear()}${upMonth > 9 ? upMonth : `0${upMonth}`}`
        const userInfo = JSON.parse(localStorage.user_info)
        const ukeyList = userInfo.sysUkeyList
        const orgId = userInfo.org.orgId
        if(null!=ukeyList && ukeyList.length>0){
            ukeyList.forEach((item) => {
                if(orgId!=item.orgId || item.diskType==1){
                    ukeyList.remove(item)
                }
            });
        }
        $scope.ukeyList = ukeyList
        $scope.selectedUkey = null
        $scope.initSuccess = false
        if($scope.ukeyList){
            $scope.selectedUkey = $scope.ukeyList[0]
        }
        function init() {
            if($scope.selectedUkey && $scope.selectedUkey.manageType=='3'){
                const requestData = {
                    taxNo: userInfo.sale.saleCreditCode,
                    machineCode: $scope.selectedUkey.diskNo
                }
                utils.loading('加载中')
                $scope.initSuccess = false
                httpRequest.post_queryDeviceInfo(requestData).then((res)=>{
                    console.log(res)
                    $scope.reportStatus = true
                    $scope.cleanStatus = true
                    var isCopyTaxTime = null //是否到抄税期
                    var submitData = null //报税资料
                    //isCopyTaxTime 为1 submitData为1 已抄税，未清卡
                    //isCopyTaxTime 为1 submitData为0 未抄税，未清卡
                    //isCopyTaxTime 为0 submitData为0 已抄税，已清卡
                    try{
                        if(res.data.value && res.data.value.businessData && res.data.value.businessData.electronicInvoice){
                            isCopyTaxTime = res.data.value.businessData.electronicInvoice.isCopyTaxTime
                            submitData = res.data.value.businessData.electronicInvoice.submitData
                        }
                        if(null==isCopyTaxTime && res.data.value && res.data.value.businessData && res.data.value.businessData.vatSpecialGeneralInvoice){
                            isCopyTaxTime = res.data.value.businessData.vatSpecialGeneralInvoice.isCopyTaxTime
                            submitData = res.data.value.businessData.vatSpecialGeneralInvoice.submitData
                        }
                        if('1'==isCopyTaxTime && '1'==submitData){
                            $scope.reportStatus = true
                            $scope.cleanStatus = false
                        }else if('1'==isCopyTaxTime && '0'==submitData){
                            $scope.reportStatus = false
                            $scope.cleanStatus = false
                        }
                        $scope.initSuccess = true
                        utils.loaded()
                    }catch (e) {
                        utils.loaded()
                        logger.logError('处理失败')
                    }

                },(error)=>{
                    utils.loaded()
                    logger.logError(error)
                })


            }else{
                collectionExportService.diskInfoFun().then((disk) => {
                    console.log(disk)
                    $scope.reportStatus = true
                    $scope.cleanStatus = true
                    $scope.diskInfo = disk
                    for (const key in disk.responseMsg.DATA) {
                        if (disk.responseMsg.DATA[key].Ssrq && disk.responseMsg.DATA[key].Ssrq.slice(0, 6) != now) {
                            $scope.reportStatus = false
                            if (disk.responseMsg.DATA[key].Bszl != '0') $scope.cleanStatus = false
                        }
                    }
                    httpRequest.fetchDeclareSign({
                        diskNo: disk.responseMsg.DATA.Jssbxx.Jspbh,
                        type: 0,
                    }).then(res => {
                        $scope.reportRes = res.data.value
                    })
                    httpRequest.fetchDeclareSign({
                        diskNo: disk.responseMsg.DATA.Jssbxx.Jspbh,
                        type: 1,
                    }).then(res => {
                        $scope.cleanRes = res.data.value
                    })
                }, (err) => {
                    logger.logError(err)
                })
            }

        }
        //init()
        $scope.showTaxInfo = false

        /*$scope.onShowTaxInfo = function () {
            $scope.showTaxInfo = !$scope.showTaxInfo
        }*/
        $scope.queryDeviceInfo = function () {
            if(null == $scope.selectedUkey){
                //提示错误信息
                logger.logError('请选择一个设备')
                return
            }
            init()
        }
        $scope.onExportManualCheck = function (flag) {
            if($scope.selectedUkey && $scope.selectedUkey.manageType=='3'){
                const requestData = {
                    taxNo: userInfo.sale.saleCreditCode,
                    machineCode: $scope.selectedUkey.diskNo
                }
                if(flag){
                    //清卡
                    utils.loading('清卡中')
                    httpRequest.post_deviceClear(requestData).then((res)=>{
                        logger.logSuccess('清卡成功')
                        utils.loaded()
                    },(error)=>{
                        console.log('清卡失败' + error)
                        utils.loaded()
                    })
                }else{
                    //上报汇总
                    utils.loading('上报汇总中')
                    httpRequest.post_reportSummary(requestData).then((res)=>{
                        logger.logSuccess('上报汇总成功')
                        utils.loaded()
                    },(error)=>{
                        console.log('上报汇总失败' + error)
                        utils.loaded()
                    })
                }
            }else{
                if (checkSoapBeforeTaxCore()) return
                if (userInfo.sale.saleCreditCode != $scope.diskInfo.TaxCode) return logger.logError('税号不一致')
                let hasPermit = false
                userInfo.sysUkeyList.forEach((item) => {
                    if (item.diskCode == $scope.diskInfo.MachineNo) hasPermit = true
                })
                if (!hasPermit) return logger.logError('未维护开票点信息或未授权')
                let reqStr = !flag ? 'ewogICAgInBhcmFtIjogIjw/eG1sIHZlcnNpb249JzEuMCcgZW5jb2Rpbmc9XCJHQktcIj8_PEZQWFRfQ09NX0lOUFVUPjxJRD4wNzAwPC9JRD48REFUQT48L0RBVEE_PC9GUFhUX0NPTV9JTlBVVD4iCn0=' : 'ew0KICAgICJwYXJhbSI6ICI8P3htbCB2ZXJzaW9uPScxLjAnIGVuY29kaW5nPVwiR0JLXCI/PjxGUFhUX0NPTV9JTlBVVD48SUQ_MDcwMTwvSUQ_PERBVEE_PC9EQVRBPjwvRlBYVF9DT01fSU5QVVQ_Ig0KfQ=='
                let text = flag ? '远程清卡' : '上报汇总'
                $uibModal.open({
                    template: collectionTip,
                    openedClass: 'mod-modal mod-modal-md',
                    controller: ['$scope', '$uibModalInstance', 'diskNo', 'sweetalert', ($scope, $uibModalInstance, diskNo, sweetalert) => {
                        $scope.config = {
                            title: '操作提醒',
                            content: `系统正在执行${text}，如长时间未相应可刷新页面`,
                            btnText: '刷新',
                        }
                        $scope.hideModal = () => {
                            $uibModalInstance.close()
                            window.location.reload()
                        }
                        useSoap(reqStr).then((res) => {
                            console.log(res)
                            collectionExportService.SID20Callback(res, flag, diskNo).then((text) => {
                                sweetalert.confirm('操作提醒', text)
                            }).finally(() => {
                                $uibModalInstance.close()
                                init()
                            })
                        })
                    }],
                    resolve: {
                        diskNo() {
                            return $scope.diskInfo.responseMsg.DATA.Jssbxx.Jspbh
                        }
                    }
                })
            }

        }



        $scope.tabs = [{
                key: 'Jssbxx',
                value: '金税设备',
            },
            {
                key: 'Zzszyptfp',
                value: '专普票',
            },
            {
                key: 'Dzfp',
                value: '电子发票',
            },
            {
                key: 'Jdcxstyfp',
                value: '机动车发票',
            },
            {
                key: 'Jsfp',
                value: '卷式发票',
            },
        ]

        $scope.showIndex = 0

        $scope.changeTabShow = (tab) => {
            $scope.showIndex = tab
        }

        $scope.cleanShowContent = false
        $scope.$_onToggleCleanShowContent = () => {
            $scope.cleanShowContent = true
        }
        $scope.$_onToggleCleanHideContent = () => {
            $scope.cleanShowContent = false
        }

        $scope.checkShowContent = false

        $scope.$_onToggleCheckShowContent = () => {
            $scope.checkShowContent = true
        }
        $scope.$_onToggleCheckHideContent = () => {
            $scope.checkShowContent = false
        }

        $scope.checkContentTooltip = $scope.reportRes && $scope.reportRes.status
        $scope.cleanContentTooltip = $scope.cleanContent && $scope.cleanContent.status

        function useSoap(paramStr) {
            let realUrl = REAL_URL.replace('8888', localStorage.soapPort)
            return new Promise((resolve, rejects) => {
                $.post({
                    url: realUrl,
                    data: {
                        SID: 20,
                        SIDParam: paramStr,
                    },
                    timeout: 30000,
                }).then((data) => {
                    const DECMSG = JSON.parse(data).ENCMSG.replace(new RegExp('[_]', 'gm'), '+')
                        .replace(new RegExp(/(\r)/g), '')
                        .replace(new RegExp(/(\n)/g), '')
                    httpRequest.post_base64DeCode({
                        invData: DECMSG,
                        codeType: 'decode',
                    }).then((res) => {
                        resolve(JSON.parse(res.data.value))
                    })
                }, () => {
                    rejects()
                })
            })
        }

    }
}
collectionExportCtrl.$inject = ['$scope', 'collectionExportService', 'httpRequest', '$uibModal', 'logger']
export default collectionExportCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/taxFilling/collectionExport/controller/collectionExportCtrl.js